import { Icon, MenuItem } from "@trimble/modus-cmx";
import type { ViewAllOptionProps } from "@/components/Navigation/GlobalHeader/GlobalSearch/types";
import { useTranslation } from "react-i18next";

export function ViewAllOption({
  totalCount,
  onViewAll,
  searchCategory,
}: ViewAllOptionProps) {
  const { t } = useTranslation();
  return (
    <MenuItem value="view-all" onItemSelect={onViewAll}>
      <div slot="start-icon" className="option-view-all">
        <span className="option-view-all-count">
          <Icon name="search" variant="solid" size="sm" decorative />
          <span>
            {t("global_search.search_results", {
              total: totalCount.toString(),
            })}
          </span>
        </span>
        <span className="option-view-all-link">
          {t("global_search.view_all", {
            category: t(`global_search.${searchCategory}`).toLowerCase(),
          })}
        </span>
      </div>
    </MenuItem>
  );
}
